import {
  put, takeLatest, call, select,
} from 'redux-saga/effects';
import api from '@/api/trial-lesson';
import {
  AVAILABLE_SLOTS_REQUEST,
  AVAILABLE_SLOTS_SUCCESS,
  MAKE_BOOKING_REQUEST,
  MAKE_BOOKING_SUCCESS,
} from '@/action-types/trial-lesson';
import { Action } from 'redux';
import { ERROR_PASS_REQUEST, ERROR_UPDATE_REQUEST } from '@/action-types/error';
import { ANALYTICS_SEND_EVENT } from '@/action-types/analytics';
import Cookies from 'js-cookie';
import { STUDENT_GET_INFO_REQUEST } from '@/action-types/student';

const getUserMarket = (country: string) => {
  const language = Cookies.get('language');

  if (language === 'pl' || country === 'PL') return 'pl';
  if (language === 'ro' || country === 'RO') return 'ro';
  return 'en';
};

export function* getAvailableSlots() {
  try {
    const state = yield select();

    const market = getUserMarket(state?.student?.data?.country);

    const response = yield call(api.getAvailableSlots, market);
    const availableSlots = response?.data?.getAvailableSlots;

    yield put({ type: AVAILABLE_SLOTS_SUCCESS, availableSlots });

    yield put({ type: ANALYTICS_SEND_EVENT, eventName: 'open_popap_trial_lesson_booking' });
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'getAvailableSlots'] });

    yield put({
      type: ERROR_UPDATE_REQUEST,
      isActive: true,
      errorData: {
        errorText: 'Oops, all time slots is already booked. Please try again later',
      },
    });
  }
}

export function* makeBooking(params: Action & {
  time: string;
  email: string;
  name: string;
}) {
  try {
    const state = yield select();

    const market = getUserMarket(state?.student?.data?.country);

    yield call(api.makeBooking, { ...params, market });

    yield put({
      type: MAKE_BOOKING_SUCCESS,
      isSended: true,
    });

    yield put({ type: STUDENT_GET_INFO_REQUEST });
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'makeBooking'] });
    yield put({
      type: MAKE_BOOKING_SUCCESS,
      isSended: false,
      errorMessage: 'Oops, the selected time slot is already booked. Please choose another time for your trial lesson',
    });
  }
}

export default function* trialLessonSaga() {
  yield takeLatest(AVAILABLE_SLOTS_REQUEST, getAvailableSlots);
  yield takeLatest(MAKE_BOOKING_REQUEST, makeBooking);
}
